export const VDRUtils = new class {

    isVDRVessel(): boolean
    {
        if (this._isVDRVessel !== null)
        {
            return this._isVDRVessel;
        }

        const imo = (<any>window)["appenv"].vesselIMONumber;
        if (!imo)
        {
            this._isVDRVessel = false;
        }
        else
        {
            this._isVDRVessel = _VDRVessels.includes(imo);
        }

        return this._isVDRVessel;
    }

    private _isVDRVessel: boolean|null = null;
}

const _VDRVessels = [
    9120841,
    9120865,
    9146467,
    9153850,
    9162215,
    9164237,
    9164275,
    9166792,
    9175779,
    9175781,
    9175793,
    9175808,
    9190731,
    9190743,
    9190755,
    9190767,
    9190779,
    9190781,
    9192442,
    9192454,
    9192466,
    9192478,
    9198575,
    9215165,
    9215177,
    9215189,
    9215191,
    9220885,
    9220897,
    9273923,
    9273961,
    9288409,
    9294161,
    9294379,
    9294381,
    9294393,
    9299032,
    9302449,
    9332676,
    9332688,
    9343077,
    9408956,
    9411367,
    9411379,
    9411381,
    9456991,
    9457000
];
